import React, {
  useContext,
} from 'react';
import IconButton from '@mui/material/IconButton';
import {
  notEmptyString,
} from '@populateui/utils';
import {
  ClaimDetailItem,
} from 'pages/Dashboard/pages/Billing/Payments/EOBDialog/Discrepancy/types';
import useDiscrepancyData from 'pages/Dashboard/pages/Billing/Payments/EOBDialog/Discrepancy/hook';
import {
  WizardContext,
} from 'pages/Dashboard/pages/Billing/Payments/EOBDialog/wizardContext';
import CollapseIcon from 'core/icons/collapse';

function renderClaimMeta(item: ClaimDetailItem) {
  return (
    <>
      <p className="text-xs font-semibold text-gray-900 leading-5">
        Claim #
        {item.claimExternalId}
      </p>
      <div className="flex items-center gap-1">
        <span className="text-xs text-gray-600">{item.patientName}</span>
        <span className="text-xs text-gray-500">•</span>
        <span className="text-xs text-gray-500">
          Visited:
          {' '}
          {item.dateOfService}
        </span>
      </div>

    </>
  );
}

export default function DiscrepancyDetailsPanel() {
  const {
    currentEOB,
    parsedEOBData,
    parsedEOBErrors,
    setIsDiscrepancyDetailsOpen,
  } = useContext(WizardContext);
  const payerName = parsedEOBData?.eob?.insuranceName
    ?? currentEOB?.eob?.insuranceName
    ?? '';
  const {
    detailSections,
    totalDiscrepancyCount,
  } = useDiscrepancyData(parsedEOBErrors);

  return totalDiscrepancyCount !== 0 ? (
    <div className="flex h-full min-h-0 flex-col bg-white">
      <div className="flex items-center gap-2 px-4">
        <IconButton
          className="!w-6 !h-6"
          onClick={() => setIsDiscrepancyDetailsOpen(false)}
          aria-label="Hide details"
        >
          <CollapseIcon className="!w-4 !h-4 !text-gray-500" />
        </IconButton>
        <h3 className="text-sm font-semibold text-gray-900 leading-5">
          Review discrepancies
        </h3>
      </div>
      <div className="flex min-h-0 flex-1 flex-col gap-4 overflow-y-auto px-4 py-4">
        {detailSections.map((section) => (
          <div key={section.key} className="flex flex-col gap-2">
            {section.variant === 'payer' ? (
              <div className="border border-gray-200 rounded-lg px-3 py-2 bg-gray-50/60">
                <p className="text-xs font-semibold text-gray-900 leading-5">
                  {section.title}
                </p>
                {notEmptyString(payerName) && (
                  <p className="text-xs text-gray-600 mt-1">
                    {payerName}
                  </p>
                )}
              </div>
            ) : (
              <>
                <div className="flex items-center justify-between gap-3">
                  <h4 className="text-xs font-semibold text-gray-900">{section.title}</h4>
                </div>
                <div className="flex flex-col gap-2">
                  {section.items.map((item) => (
                    <div
                      key={item.key}
                      className="border border-gray-200 rounded-lg px-3 py-2 bg-gray-50/60"
                    >
                      {renderClaimMeta(item)}
                      {section.variant === 'service-line' && 'serviceLines' in item && (
                        <div className="mt-2 flex flex-col gap-1">
                          <ul className="list-disc pl-5 flex flex-col gap-1">
                            {item.serviceLines.map((serviceLine) => (
                              <li
                                key={serviceLine}
                                className="text-xs text-gray-600 font-medium leading-5"
                              >
                                {serviceLine}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  ) : null;
}
